module.exports = __webpack_public_path__ + "static/media/peopleGroup4.5fae4954.jpg";